import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import Hero from './Hero/Hero';
import './Expertise.css';
import ExpertiseBody from './ExpertiseBody/ExpertiseBody';
import Innovation from './Innovation/Innovation';
import ComponentData from './data.json';

const Expertise = ({ isDesktop }) => {
    return (
        <div className="expertise">
            <Helmet>
                <title>Expertise | HPP</title>
                <meta
                    name="description"
                    property="og:description"
                    content="Responsible operations are a cornerstone of our promise to deliver for all our stakeholders.
                             We have immediate priorities and a long-term vision to protect the environment and help tenants,
                             employees and local communities prosper."
                />
            </Helmet>

            <Hero />

            <div className='expertise-bg'>
                {ComponentData.sections.map((blockData, index) => {
                    return (
                        <ExpertiseBody key={index} index={index + 1} blockData={blockData} isDesktop={isDesktop} />
                    );
                })}
            </div>

            <Innovation />
        </div>
    );
};

Expertise.propTypes = {
    isDesktop: PropTypes.bool,
};

export default Expertise;
